import type { FC, PropsWithChildren, ReactNode } from 'react';

interface ContractBuilderBaseLoadingProps {
  headerRow?: ReactNode;
}

export const ContractBuilderBaseLoading: FC<PropsWithChildren<ContractBuilderBaseLoadingProps>> = ({
  children,
  headerRow,
}) => {
  return (
    <div role="status" className="flex h-screen w-full flex-col bg-white" data-testid="loading-overlay">
      <div className="flex h-[86px] shrink-0 animate-pulse items-start justify-between px-5 pt-3">
        <div className="flex flex-col">
          <div className="flex h-9 items-center gap-x-2">
            <div className="bg-info-200 h-7 w-7 rounded-full" />
            <div className="bg-info-200 h-4 w-28 rounded-full" />
            <div className="bg-info-200 ml-8 h-3 w-72 rounded-full" />
          </div>
          <div className="flex h-[26px] items-center gap-x-4 pl-9">
            <div className="bg-info-200 h-3 w-28 rounded-full" />
            <div className="bg-info-200 h-3 w-24 rounded-full" />
            <div className="bg-info-200 h-3 w-20 rounded-full" />
            <div className="bg-info-200 h-3 w-28 rounded-full" />
          </div>
        </div>
        <div className="flex -translate-x-10 items-center gap-x-1">
          <div className="bg-info-200 h-8 w-[103px] rounded-md"></div>
          <div className="bg-info-200 h-8 w-[126px] rounded-md"></div>
        </div>
        <div className="flex items-center gap-x-3">
          <div className="bg-info-100 h-8 w-8 rounded-full" />
          <div className="bg-info-100 h-8 w-8 rounded-full" />
          <div className="bg-info-100 h-8 w-8 rounded-full" />
          <div className="bg-info-100 h-8 w-8 rounded-full" />
          <div className="bg-info-100 h-8 w-8 rounded-full" />
          <div className="bg-info-200 ml-2 h-9 w-32 rounded-md" />
          <div className="bg-info-100 ml-2 h-8 w-8 rounded-full" />
        </div>
      </div>
      <div className="border-info-200 border-b"></div>
      {headerRow}
      <div className="bg-info-50 relative flex h-full w-full overflow-hidden overflow-y-hidden">{children}</div>
      <span className="sr-only" data-testid="contract-builder-loading-overlay">
        Loading...
      </span>
    </div>
  );
};
